import { css } from 'styled-components';
import { StyledPaginationList } from '../../components/PaginationList/PaginationList.styles';
import { StyledPaginationNumberItem } from '../../components/PaginationNumberItem/PaginationNumberItem.styles';
import { StyledPaginationReadoutItem } from '../../components/PaginationReadoutItem/PaginationReadoutItem.styles';
import { inlineMediaQueryMixin } from '../inlineMediaQueryMixin';
import { mediaQueryMixin } from '../mediaQueryMixin';
import { spacingMixin } from '../spacingMixin';
var showNumberButtonsCSS = inlineMediaQueryMixin('showNumberButtons', function (_ref) {
  var showNumberButtons = _ref.showNumberButtons;
  return css(["", "{justify-content:", ";}", "{display:", ";}", "{display:", ";}"], StyledPaginationList, showNumberButtons ? 'center' : 'space-between', StyledPaginationNumberItem, showNumberButtons ? 'block' : 'none', StyledPaginationReadoutItem, showNumberButtons ? 'none' : 'block');
});

/** @class PaginationMixin */
/** @method */
export var PaginationMixin = function PaginationMixin(props) {
  return css(["display:block;margin-left:auto;margin-right:auto;width:100%;user-select:none;", " ", " ", ""], spacingMixin(props), showNumberButtonsCSS(props), mediaQueryMixin(function (mediaProps) {
    return showNumberButtonsCSS(Object.assign({}, mediaProps));
  }));
};